<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  scheduleCount: {
    type: Number,
    required: true,
  },
  maxSchedules: {
    type: Number,
    required: true,
  },
  isWithinLimit: {
    type: Boolean,
    required: true,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="space-y-3">
    <div
      class="rounded-lg p-4 border"
      :class="[
        isWithinLimit
          ? 'bg-woot-50 dark:bg-woot-900 border-woot-400 dark:border-woot-400'
          : 'bg-red-50 dark:bg-red-900 border-red-200 dark:border-red-800',
      ]"
    >
      <div class="flex items-center justify-between mb-2">
        <h4
          class="font-medium flex items-center gap-2"
          :class="[
            isWithinLimit
              ? 'text-blue-900 dark:text-blue-100'
              : 'text-red-900 dark:text-red-100',
          ]"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
          {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.LIMIT.TITLE') }}
        </h4>
        <span
          class="px-3 py-1 rounded-full text-sm font-medium"
          :class="[
            isWithinLimit
              ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
              : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
          ]"
        >
          {{ `${scheduleCount} / ${maxSchedules}` }}
        </span>
      </div>

      <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2 mb-3">
        <div
          class="h-2 rounded-full transition-all duration-500"
          :class="isWithinLimit ? 'bg-blue-500' : 'bg-red-500'"
          :style="{
            width: Math.min(100, (scheduleCount / maxSchedules) * 100) + '%',
          }"
        />
      </div>

      <p
        class="text-sm"
        :class="[
          isWithinLimit
            ? 'text-blue-700 dark:text-blue-300'
            : 'text-red-700 dark:text-red-300',
        ]"
      >
        <span v-if="isWithinLimit">
          {{
            t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.LIMIT.WITHIN', {
              count: scheduleCount,
              remaining: maxSchedules - scheduleCount,
            })
          }}
        </span>
        <span v-else>
          {{
            t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.LIMIT.EXCEEDED', {
              count: scheduleCount,
              max: maxSchedules,
            })
          }}
        </span>
      </p>
    </div>
  </div>
</template>
